import { render, staticRenderFns } from "./plPrivacy.vue?vue&type=template&id=b0aa9874&scoped=true&"
import script from "./plPrivacy.vue?vue&type=script&lang=js&"
export * from "./plPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./plPrivacy.vue?vue&type=style&index=0&id=b0aa9874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aa9874",
  null
  
)

export default component.exports